import { render, staticRenderFns } from "./ServiceOne.vue?vue&type=template&id=6c285311&scoped=true&"
import script from "./ServiceOne.vue?vue&type=script&lang=js&"
export * from "./ServiceOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c285311",
  null
  
)

export default component.exports